import { render } from "./SettingsInfoDialog.vue?vue&type=template&id=64857adc&ts=true"
import script from "./SettingsInfoDialog.vue?vue&type=script&lang=ts"
export * from "./SettingsInfoDialog.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\2f08168a1cda37d3\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__